import * as Yup from 'yup';
import { getRequiredText } from '../../../global/helpers/transformer';
import { LabelSettingProps } from '../../../global/models/epi-model';
import { ClergyBioSettings } from '../../arc/models/arc-epi-props';
import { Education } from '../model/clergy-bio-app-models';
import { Other } from './clergy-bio-education-item';
import { ClergyBioEducationFormModel } from './models/form-models';

export function GetClergyBioEducationValidationSchema(settings: ClergyBioSettings, labelSetting: LabelSettingProps) {

	const educationShape = Yup.object().shape({
		institution: Yup.string().required(getRequiredText(labelSetting.requiredFormat, settings.institutionLabel)),
	});

	return Yup.object().shape({
		theological: Yup.array()
			.of(educationShape),
		other: Yup.array()
			.of(educationShape),
	});
}

enum EducationType {
	THEOLOGICAL = 'THEOLOGICAL',
	OTHER = 'OTHER',
}

function transformToEducationPayload(education: Education, other?: boolean, toDelete?: boolean) {
	return {
		id: education?.id,
		degree: education?.degree === Other ? education?.degreeOther : education?.degree,
		field: education?.field,
		graduation_year: education?.year,
		institution: education?.institution === Other ? education?.institutionOther : education?.institution,
		school_type: other ? EducationType.OTHER : EducationType.THEOLOGICAL,
		action: toDelete ? 'delete' : null,
	};
}

export function ConstructPayload(values: ClergyBioEducationFormModel, defaultValues: ClergyBioEducationFormModel) {

	const theologicalToDelete =
		defaultValues?.
			theological?.
			filter(t => values?.theological?.filter(tv => tv?.id === t?.id)?.length === 0)?.
			map(d => transformToEducationPayload(d, false, true));
	const otherToDelete =
		defaultValues?.
			other?.
			filter(t => values?.other?.filter(tv => tv?.id === t?.id)?.length === 0)?.
			map(d => transformToEducationPayload(d, true, true));
	return {
		educations: {
			theological: values?.theological?.map(a => transformToEducationPayload(a))?.concat(theologicalToDelete),
			other: values?.other?.map(a => transformToEducationPayload(a, true))?.concat(otherToDelete),
		},
	};
}

export function getNewEducation() {
	return {
		field: '',
		degree: '',
		institution: '',
		year: '',
		degreeOther: '',
		institutionOther: '',
	};
}

export function updateEducation(education: Education) {
	return {
		...education,
		instituion: education?.institutionOther ? Other : education.institution,
		degree: education?.degreeOther ? Other : education.degree,
	};
}